import Vue from "vue";
import router from "../../services/router/index";

const getRetryAfter = (error) => {
  const headers = error?.response?.headers || {};
  const getHeader = (name) =>
    typeof headers.get === "function"
      ? headers.get(name)
      : headers[name.toLowerCase()] || headers[name];
  const retryAfter = getHeader("Retry-After");
  const seconds = Number(retryAfter);

  if (Number.isFinite(seconds)) {
    return Math.max(0, Math.ceil(seconds));
  }

  const retryDate = Date.parse(retryAfter);
  if (!Number.isNaN(retryDate)) {
    return Math.max(0, Math.ceil((retryDate - Date.now()) / 1000));
  }

  const rateLimit = getHeader("RateLimit");
  const rateLimitSeconds = /(?:^|;)\s*t=(\d+)/i.exec(rateLimit)?.[1];

  if (rateLimitSeconds) {
    return Number(rateLimitSeconds);
  }

  return 60;
};

const handleRateLimit = (commit, error) => {
  if (error?.response?.status !== 429) {
    return false;
  }

  commit("SET_RATE_LIMIT", {
    seconds: getRetryAfter(error),
    timestamp: Date.now(),
  });
  return true;
};

export default {
  state: {
    userData: null,
    authResult: null,
    loginError: null,
    smsError: null,
    rateLimit: null,
    balance: null,
  },

  mutations: {
    SET_USER_DATA(state, payload) {
      state.userData = payload;
    },

    SET_AUTH(state, payload) {
      state.authResult = payload.success;
      localStorage.setItem("jwt", payload.jwt);
      router.push({ name: "home" });
    },

    CLEAR_AUTH(state) {
      state.authResult = null;
      localStorage.removeItem("jwt");
    },

    LOGIN_ERROR(state, payload) {
      state.loginError = payload;
    },

    SMS_ERROR(state, payload) {
      state.smsError = payload;
    },

    SET_RATE_LIMIT(state, payload) {
      state.rateLimit = payload;
    },

    USER_BALANCE(state, payload) {
      state.balance = payload;
    },
  },

  actions: {
    requestOtp({ commit }, userData) {
      commit("LOGIN_ERROR", null);
      commit("SMS_ERROR", null);
      commit("SET_RATE_LIMIT", null);
      localStorage.removeItem("jwt");

      return Vue.http
        .post("/api/otp", {
          phone: userData.tel,
        })
        .then(() => {
          commit("SET_USER_DATA", { tel: userData.tel });
          return true;
        })
        .catch((error) => {
          if (!handleRateLimit(commit, error)) {
            commit("LOGIN_ERROR", error);
          }
          return false;
        });
    },

    login({ commit, state }, smsCode) {
      commit("SMS_ERROR", null);
      commit("SET_RATE_LIMIT", null);

      const bodyParameters = {
        phone: state.userData.tel,
        ...smsCode,
      };

      return Vue.http
        .post("/api/login", bodyParameters)
        .then((response) => {
          const token = response?.data?.token;

          if (typeof token !== "string" || !token.trim()) {
            throw new Error("Login response does not contain a valid token");
          }

          const result = {
            jwt: token.trim(),
            success: true,
          };
          commit("SET_AUTH", result);
          return true;
        })
        .catch((error) => {
          if (!handleRateLimit(commit, error)) {
            commit("SMS_ERROR", error);
          }
          return false;
        });
    },

    getMeBalance({ commit }) {
      Vue.http
        .get("/api/me/balance")
        .then((response) => {
          commit("USER_BALANCE", response);
        })
        .catch((error) => {
          if (error?.response && error?.response?.status === 500) {
            this.$toast("Ой, что-то пошло не так", {
              timeout: 5000,
              type: "error",
            });
          }
          console.log(error);
        });
    },
  },
};
